import styled from 'styled-components';

import Input from 'components/Controls/Input';

export const MultiFilters = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;

export const Row = styled.div`
  display: flex;
  column-gap: 10px;
`;

export const StyledInput = styled(Input)`
  flex: 1 1 auto;
  min-width: 0;
`;
